import {Grid, ListItemText, MenuItem, TextField} from "@mui/material";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {BASIC_FEE, RENEW_INVOICE, RENT_DAYS, STANDARD} from "../../mobilitystore/constants/SubscriptionConfiguration";

function SubscriptionConfigurationInstances({row, index, data, setData, setEnableUpdate, setEnableCreation, isFirstConfiguration}: any) {

    const {t} = useTranslation("finance", {keyPrefix: "clusters"});
    const integerNumber =  /^-?\d*?$/;
    function handleOnChange(value: any, variableName: string) {
        let originData = [...data]
        originData[index][variableName] = value;
        setData(originData)
        setEnableUpdate(true)
        setEnableCreation(isFirstConfiguration && checkClusterConfiguration(data))
    }

    function checkClusterConfiguration(data:any) {
        let validConfiguration = false;
        data.forEach((conf: any) => {
            validConfiguration = conf.algorithm !== "" && conf.commissionType !== ""
        })
        return validConfiguration;
    }

    const algorithmTypes = [
        {
            label: t("subscriptions.algorithm-types." + RENEW_INVOICE),
            value: RENEW_INVOICE,
            selected: true
        },
        {
            label: t("subscriptions.algorithm-types." + BASIC_FEE),
            value: BASIC_FEE
        }
    ];

    const commissionTypes = [
        {
            label: t("subscriptions.commission-types." + STANDARD),
            value: STANDARD,
            selected: true
        },
        {
            label: t("subscriptions.commission-types." + RENT_DAYS),
            value: RENT_DAYS
        }
    ];

    return (
        <Grid container columnSpacing={3}>
            <Grid item xs={3}>
                <TextField
                    fullWidth
                    value={t("printout-types." + row.printoutType)}
                    variant="standard"
                    InputProps={{
                        readOnly: true,
                    }}
                    InputLabelProps={{shrink: true}}
                />
            </Grid>
            <Grid item xs={3}>
                <TextField fullWidth
                           select
                           value={row.algorithm}
                           variant="standard"
                           onChange={e => handleOnChange(e.target.value, "algorithm")}
                >
                    {algorithmTypes.map((type) => (
                        <MenuItem key={type.value} value={type.value}>
                            <ListItemText primary={type.label} />
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid item xs={3}>
                <TextField fullWidth
                           select
                           value={row.commissionType}
                           onChange={e => {
                               if(e.target.value === STANDARD) {
                                   handleOnChange(0, "coefficient")
                               }
                               handleOnChange(e.target.value, "commissionType")
                           }}
                >
                    {commissionTypes.map((type) => (
                        <MenuItem key={type.value} value={type.value}>
                            <ListItemText primary={type.label} />
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid item xs={3}>
                <TextField
                    fullWidth
                    variant="standard"
                    value={row.coefficient}
                    type="number"
                    disabled={row.commissionType === STANDARD}
                    onChange={e => {
                        const value = e.target.value;
                        const isMatch = integerNumber.test(value);
                        if (isMatch || value === "") { handleOnChange(e.target.value, "coefficient") }
                    }}
                    InputLabelProps={{shrink: true}}
                    InputProps={{
                        inputProps: {
                            style: { textAlign: "center" }
                        }
                    }}
                />
            </Grid>
        </Grid>
    );
}

export default SubscriptionConfigurationInstances;
